/** What a thread row is called when nothing better is known. */
const PLACEHOLDER = 'Conversation';

/**
 * @desc The title shown for a conversation in the sidebar, in order of preference: the agent's
 * summary, then the conversation's first user message, then a literal placeholder.
 *
 * The middle step exists because a summary is not guaranteed. A `Summarisation` event may never
 * arrive for a one-turn chat — the summariser can decline and send a note instead — and until it
 * does, every such thread is called "Conversation", which makes the list unreadable when several
 * are open. The user's own opening words are the best label available in the meantime and are
 * what they would recognise the thread by.
 *
 * The row clamps with a single-line CSS ellipsis, so the fallback is whitespace-collapsed rather
 * than cut to a character count: the same clamp then does the truncating, at the same visual
 * length as every other row.
 */
export function conversationTitle(
  summary: string | null | undefined,
  firstPrompt: string | null | undefined,
): string {
  const trimmedSummary = summary?.trim();
  if (trimmedSummary) return trimmedSummary;

  const collapsedPrompt = firstPrompt?.replace(/\s+/g, ' ').trim();
  if (collapsedPrompt) return collapsedPrompt;

  return PLACEHOLDER;
}
